import DocumentSigning from './DocumentSigning'

export default {
    DocumentSigning
}
